export enum StatusZawiadomienia {
  Nowe = 1,
  Zatwierdzono,
  Wyslano,
  Doreczono,
  Zweryfikowano,
  PrzekazanoDoPodpisu,
}
